import {
  Icon,
  SelectionCard,
  Button,
  Typography,
  BUTTON_SIZE,
  BUTTON_VARIANT
} from '@sanlam-glacier/app-common/components';
import { PdfGetStaticPdfPdfEnum, useGetStaticPdf } from 'bff';
import { useIsMounted } from '@sanlam-glacier/app-common/hooks';
import { environmentService } from 'stores/store';
import './support.style.scss';

export const SupportPage = () => {
  const supportEmail = environmentService.getSupportEmail();
  const mounted = useIsMounted();
  const selectionCardData = [
    {
      title: 'Got a question?',
      subtitle: 'Send a help request to: ',
      icon: <Icon icon={'communication_email'} />
    },
    {
      title: 'Explore our Glacier Hub user manual',
      subtitle: 'Your go-to source for any questions',
      icon: <Icon icon={'av_library-books'} />
    }
  ];

  const { mutateAsync: downloadStaticPdf, isPending: isPdfDownloading } = useGetStaticPdf({
    meta: {
      errorMessage: 'Failed to get pdf. Please try again later'
    }
  });

  const downloadPdf = async () => {
    const downloaded = await downloadStaticPdf({
      pdf: PdfGetStaticPdfPdfEnum.GlacierHubUserManualEnglishGaf
    });

    if (downloaded != undefined) {
      const anchorElement = document.createElement('a');
      document.body.appendChild(anchorElement);

      anchorElement.style.display = 'none';

      const pdf = URL.createObjectURL(downloaded);

      anchorElement.href = pdf;
      anchorElement.download = 'Glacier Hub - User Manual - June 2025 Training.pdf';
      anchorElement.click();
    }
  };

  return (
    <>
      <Typography variant={Typography.VARIANT.H2} weight={Typography.WEIGHT.BOLD}>
        Need support?
      </Typography>
      <br />
      <div className='selections-support'>
        {selectionCardData.map((selectionCard, index) => (
          <div key={index} className='selection-card-wrapper'>
            <SelectionCard
              className={`selection-card-support ${mounted ? 'fade-in' : ''}`}
              size={SelectionCard.SIZE.SMALL}
              title={
                <div>
                  <div className='selection-icon'>
                    <Typography variant={Typography.VARIANT.H1}>{selectionCard.icon}</Typography>
                  </div>
                  <Typography
                    variant={Typography.VARIANT.H4}
                    weight={Typography.WEIGHT.MEDIUM}
                    align={Typography.ALIGN.LEFT}
                  >
                    {selectionCard.title}
                  </Typography>
                  <hr className='short' />
                </div>
              }
              subtitle={
                <div className='content-wrapper'>
                  <div className='content'>
                    <div className='main-content-support'>
                      <Typography color={Typography.COLOR.TERTIARY} variant={Typography.VARIANT.B2}>
                        {selectionCard.subtitle}
                        {selectionCard.title === 'Got a question?' && supportEmail.length > 0 && (
                          <a href={`mailto:${supportEmail}`}>
                            <span className='email'>{supportEmail}</span>
                          </a>
                        )}
                        {selectionCard.title === 'Got a question?' && supportEmail === '' && (
                          <span className='email'>[Placeholder]</span>
                        )}
                      </Typography>
                    </div>
                    <div className='btn-holder-support'>
                      {selectionCard.title === 'Got a question?' ? (
                        <Button
                          variant={BUTTON_VARIANT.TERTIARY}
                          size={BUTTON_SIZE.SMALL}
                          startIcon={<Icon icon='content_copy' />}
                          onClick={async () => await navigator.clipboard.writeText(supportEmail)}
                          disabled={false}
                        >
                          Copy email address
                        </Button>
                      ) : (
                        <Button
                          variant={BUTTON_VARIANT.TERTIARY}
                          size={BUTTON_SIZE.SMALL}
                          startIcon={<Icon icon='file_download' />}
                          onClick={downloadPdf}
                          loading={isPdfDownloading}
                          disabled={false}
                        >
                          Download user manual
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        ))}
      </div>
    </>
  );
};
